import Footer from "./components/Footer";
import Header from "./components/Header";
import {BrowserRouter as Router, Routes, Route, useLocation} from 'react-router-dom';
import axios from 'axios';
import config from './config';
import { isAdmin } from './utils/auth';
import MaintenancePage from "./components/MaintenancePage";
import Products from "./components/Products";
import ProductDetails from "./components/ProductDetails";
import UserPanel from "./components/UserPanel";
import Login from "./components/Login";
import React, {useEffect, useState} from 'react'
import Registration from "./components/Registration";
import Cart from "./components/Cart";
import AdminPanel from "./components/AdminPanel";
import Shipping from "./components/Shipping";
import AboutUs from "./components/AboutUs";
import Installation from "./components/Installation";
import Blogs from "./components/Blogs";
import BlogDetails from "./components/BlogDetails";
import UploadProductForm from "./components/UploadProductForm";
import UpdateProductForm from "./components/UpdateProductForm";
import DeliveryPriceForm from "./components/DeliveryPriceForm";
import OrderSuccess from "./components/OrderSuccess";
import NotFound from "./components/NotFound";
import LanguageSelector from "./components/LanguageSelector";
import WelcomeCountryModal from "./components/WelcomeCountryModal";
import WhatsAppButton from "./components/WhatsAppButton";
import { FcContacts } from "react-icons/fc";
import Contacts from "./components/Contacts"
import Assembly from "./components/Assembly";
import { PRODUCT_CATEGORIES } from "./constants/productCategories";

const MAINTENANCE_BYPASS_PATHS = ["/login", "/register"];

function AppContent() {
    const [cart, setCart] = useState([]);
    const [maintenanceMode, setMaintenanceMode] = useState(false);
    const location = useLocation();

    useEffect(() => {
        axios.get(`${config.API_URL}/api/settings/maintenance`)
            .then(response => setMaintenanceMode(response.data.maintenanceMode))
            .catch(() => setMaintenanceMode(false));
    }, [location.pathname]);

    if (maintenanceMode && !isAdmin() && !MAINTENANCE_BYPASS_PATHS.includes(location.pathname)) {
        return (
            <Routes>
                <Route path="/login" element={<Login/>}></Route>
                <Route path="/register" element={<Registration/>}></Route>
                <Route path="*" element={<MaintenancePage/>}></Route>
            </Routes>
        );
    }

    return (
        <>
            <Header cart={cart}/>
            <LanguageSelector/>
            <WelcomeCountryModal/>
            <WhatsAppButton/>
            <Routes>
                <Route path="/" element={<Products/>}></Route>
                <Route path="/kids-play" element={<Products category={PRODUCT_CATEGORIES[0].value}/>}></Route>
                <Route path="/family-play" element={<Products category={PRODUCT_CATEGORIES[1].value}/>}></Route>
                <Route path="/product/:id" element={<ProductDetails cart={cart} setCart={setCart}/>}></Route>
                <Route path="/user" element={<UserPanel/>}></Route>
                <Route path="/shipping" element={<Shipping/>}></Route>
                <Route path="/login" element={<Login/>}></Route>
                <Route path="/register" element={<Registration/>}></Route>
                <Route path="/cart" element={<Cart cart={cart} setCart={setCart}/>}></Route>
                <Route path="/admin" prefetch={false} element={<AdminPanel/>}></Route>
                <Route path="/about" element={<AboutUs/>}></Route>
                <Route path="/installation" element={<Installation/>}></Route>
                <Route path="/assembly" element={<Assembly/>}></Route>
                 {/* <Route path="/blogs" element={<Blogs/>}></Route> */}
                 {/* <Route path="/blog/:id" element={<BlogDetails/>}></Route> */}
                  <Route path="/contacts" element={<Contacts/>}></Route>
                 <Route path="/admin/uploadProduct" element={<UploadProductForm/>}></Route>
                 <Route path="/admin/updateProduct/:id" element={<UpdateProductForm/>}></Route>
                 <Route path="/admin/deliveryPrice/new" element={<DeliveryPriceForm/>}></Route>
                 <Route path="/admin/deliveryPrice/:id" element={<DeliveryPriceForm/>}></Route>
                 <Route path="/orderCreated" element={<OrderSuccess/>}></Route>
                 <Route path="/404" element={<NotFound />} />
                   <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer/>
        </>
    )
}

function App() {
    return (
        <Router>
            <AppContent/>
        </Router>
    )
}

export default App;
